import { useRef } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { DISCONNECT_BODY } from './calendarCopy';

// The dialog renders outside the page root, so it carries amp-block itself (R1-L3-002).
export default function DisconnectDialog({ connection, isDisconnecting, onCancel, onConfirm }) {
  // Keeps the email in the title while the dialog fades out after `connection` is cleared.
  const lastConnection = useRef(null);
  if (connection) lastConnection.current = connection;
  return (
    <Dialog className="amp-block" open={Boolean(connection)} onClose={() => !isDisconnecting && onCancel()}>
      <DialogTitle>Disconnect {lastConnection.current?.accountEmail}?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">{DISCONNECT_BODY}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" disabled={isDisconnecting} onClick={onCancel}>
          Cancel
        </Button>
        <LoadingButton color="error" variant="contained" loading={isDisconnecting} onClick={onConfirm}>
          Disconnect
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
